module.exports = __webpack_public_path__ + "static/media/Logo.78b332eb.svg";